import { Row } from 'react-bootstrap';
import styled, { createGlobalStyle } from 'styled-components';
import { Button } from 'v3/components';
import ListItem from '@mui/material/ListItem';

export const RowStyled = styled(Row)`
  margin-top: 3%;
`;

export const ButtonNewPanel = styled(Button)`
  margin-top: 2em;
`;

export const ScrollDiv = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(90vh - 280px);
  height: calc(90vh - 280px);
  width: 100%;
`;

export const ButtonStyled = styled(Button)`
  margin-right: 0.5rem;
`;

export const PanelListItem = styled(ListItem)`
  &:hover {
    background: #f5f6f8;
  }
`;

export const DeletePanelModalZIndex = createGlobalStyle`
  .delete-panel-modal {
    z-index: 10003 !important;
  }

  .delete-panel-modal-backdrop {
    z-index: 10002 !important;
  }
`;
